import { apiFiles } from "@/api/file.api.ts";
import { CustomFieldRendererProps } from "@/components/custom-field/edit/custom-field-edit.type.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import { ApiCFEntityTypes } from "@/types/custom-field.types.ts";
import { ApiFilePathTypes } from "@/types/file.types.ts";
import { CustomFieldFile, CustomFieldUploadedFile } from "@skailer-com/uikit";

export function CustomFieldEditFile(props: CustomFieldRendererProps) {
  const { field } = props;
  const { handleErrors } = useErrorHandle();

  const uploadFile = async (file: File): Promise<CustomFieldUploadedFile | null> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "path",
      field.entity_type === ApiCFEntityTypes.applicant
        ? ApiFilePathTypes.other
        : ApiFilePathTypes.employee
    );
    formData.append("is_public", "true");
    formData.append("save_original_name", "true");

    const { data, error } = await apiFiles.add(formData);
    if (!data) {
      handleErrors(error);
      return null;
    }

    const { data: signedLink } = await apiFiles.getLink(data.uuid, 1);
    return { ...data, url: signedLink?.download_url ?? "" };
  };

  return <CustomFieldFile {...props} onUploadFile={uploadFile} />;
}
